/* =============================================================================
   DiSEGNO Builder — "Save your DiSEGNO" dialog (host page)
   -----------------------------------------------------------------------------
   Opened by disegno.viewer.js when the builder's Save button is pressed. Asks
   for an email plus an OPTIONAL, unticked marketing-consent box, then calls
   Disegno.SavedDesign.save(), which builds the recovery link and sends
   "DiSEGNO Design Saved" to Klaviyo. On success the link is also shown here
   with a Copy button, so the customer has it even before the email lands.

   Copy comes from the DiSEGNO Builder section settings (DisegnoConfig.copy);
   the Klaviyo list for opt-ins from DisegnoConfig.saved.klaviyoListId.
   ========================================================================== */
(function (root, doc) {
  'use strict';
  var Disegno = (root.Disegno = root.Disegno || {});
  if (Disegno.SaveDialog) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var el = null, lastFocus = null, busy = false, current = null;

  function cfg() { return root.DisegnoConfig || {}; }
  function copy(k, fallback) { var c = cfg().copy || {}; return c[k] || fallback; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function injectStyles() {
    if (doc.getElementById('dsg-save-styles')) return;
    var css =
      '.dsg-save{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(20,8,4,.55)}' +
      '.dsg-save[hidden]{display:none}' +
      '.dsg-save__card{position:relative;width:100%;max-width:440px;max-height:calc(100vh - 32px);overflow:auto;box-sizing:border-box;padding:32px 28px 26px;border-radius:18px;' +
        'background:#c33820;color:#f0da7b;border:1px solid #dcc06a;font-family:"Archivo",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;box-shadow:0 24px 60px rgba(0,0,0,.35)}' +
      '.dsg-save__title{margin:0 0 8px;font-family:"Bodoni Moda","Didot","Times New Roman",serif;font-weight:400;font-size:28px;line-height:1.15;letter-spacing:.01em}' +
      '.dsg-save__body{margin:0 0 20px;font-size:15px;line-height:1.5}' +
      '.dsg-save__label{display:block;margin:0 0 6px;font-size:12px;letter-spacing:.12em;text-transform:uppercase}' +
      '.dsg-save__input{display:block;width:100%;box-sizing:border-box;height:48px;padding:0 14px;border-radius:11px;border:1px solid #dcc06a;background:#b13320;color:#f0da7b;font:inherit;font-size:16px}' +
      '.dsg-save__input::placeholder{color:#f0da7b;opacity:.6}' +
      '.dsg-save__input:focus,.dsg-save__btn:focus-visible,.dsg-save__x:focus-visible,.dsg-save__check input:focus-visible{outline:2px solid #f0da7b;outline-offset:2px}' +
      '.dsg-save__input[aria-invalid="true"]{border-color:#f0da7b;border-width:2px}' +
      '.dsg-save__err{min-height:20px;margin:6px 0 0;font-size:13px}' +
      '.dsg-save__check{display:flex;gap:10px;align-items:flex-start;margin:10px 0 22px;font-size:13px;line-height:1.45;cursor:pointer}' +
      '.dsg-save__check input{flex:0 0 auto;width:18px;height:18px;margin:1px 0 0;accent-color:#f0da7b}' +
      '.dsg-save__btn{display:flex;align-items:center;justify-content:center;width:100%;height:50px;border-radius:999px;border:1px solid #f0da7b;background:#f0da7b;color:#c33820;' +
        'font:inherit;font-size:15px;font-weight:600;letter-spacing:.04em;cursor:pointer}' +
      '.dsg-save__btn:hover{background:#e6ce68}' +
      '.dsg-save__btn[disabled]{opacity:.6;cursor:progress}' +
      '.dsg-save__btn--ghost{margin-top:10px;background:transparent;color:#f0da7b}' +
      '.dsg-save__btn--ghost:hover{background:#b13320}' +
      '.dsg-save__x{position:absolute;top:10px;right:10px;width:40px;height:40px;border:0;border-radius:50%;background:transparent;color:#f0da7b;font-size:24px;line-height:1;cursor:pointer}' +
      '.dsg-save__link{display:block;width:100%;box-sizing:border-box;margin:0 0 14px;padding:12px 14px;border-radius:11px;background:#b13320;border:1px solid #dcc06a;' +
        'color:#f0da7b;font-size:13px;word-break:break-all;user-select:all}' +
      '.dsg-save__fine{margin:14px 0 0;font-size:12px;line-height:1.45;opacity:.85}' +
      '@media (max-width:480px){.dsg-save{align-items:flex-end;padding:0}.dsg-save__card{max-width:none;border-radius:18px 18px 0 0;padding:28px 20px 22px}}';
    var s = doc.createElement('style');
    s.id = 'dsg-save-styles';
    s.textContent = css;
    doc.head.appendChild(s);
  }

  function build() {
    if (el) return el;
    injectStyles();
    el = doc.createElement('div');
    el.className = 'dsg-save';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'dsg-save-title');
    doc.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.closest('[data-dsg-close]')) close();
    });
    el.addEventListener('keydown', onKey);
    return el;
  }

  function formHtml() {
    var fine = copy('save_fine_print', '');
    return '<div class="dsg-save__card">' +
      '<button type="button" class="dsg-save__x" data-dsg-close aria-label="Close">&times;</button>' +
      '<h2 class="dsg-save__title" id="dsg-save-title">' + esc(copy('btn_save', 'Save your DiSEGNO')) + '</h2>' +
      '<p class="dsg-save__body">' + esc(copy('save_prompt', 'Enter your email to save this design and pick it up later.')) + '</p>' +
      '<form novalidate data-dsg-form>' +
        '<label class="dsg-save__label" for="dsg-save-email">' + esc(copy('save_email_label', 'Email')) + '</label>' +
        '<input class="dsg-save__input" id="dsg-save-email" name="email" type="email" autocomplete="email" inputmode="email" required ' +
          'placeholder="' + esc(copy('save_email_placeholder', 'you@example.com')) + '" aria-describedby="dsg-save-err">' +
        '<p class="dsg-save__err" id="dsg-save-err" role="alert"></p>' +
        '<label class="dsg-save__check"><input type="checkbox" name="marketing"><span>' +
          esc(copy('save_consent_label', 'Also send me news and offers from Di Volpe. You can unsubscribe at any time.')) + '</span></label>' +
        '<button class="dsg-save__btn" type="submit">' + esc(copy('save_submit', 'Email me my design')) + '</button>' +
      '</form>' +
      (fine ? '<p class="dsg-save__fine">' + esc(fine) + '</p>' : '') +
    '</div>';
  }

  function successHtml(res) {
    var url = res.recovery_url || '';
    var note = res.klaviyo === 'sent' ? copy('save_success', 'Saved. Check your inbox for a link back to this design.')
      : copy('save_success_no_email', 'Saved. Keep this link to come back to your design.');
    return '<div class="dsg-save__card">' +
      '<button type="button" class="dsg-save__x" data-dsg-close aria-label="Close">&times;</button>' +
      '<h2 class="dsg-save__title" id="dsg-save-title">' + esc(copy('save_success_title', 'Your DiSEGNO is saved')) + '</h2>' +
      '<p class="dsg-save__body" role="status">' + esc(note) + '</p>' +
      (url ? '<span class="dsg-save__link" data-dsg-link>' + esc(url) + '</span>' +
        '<button class="dsg-save__btn" type="button" data-dsg-copy>' + esc(copy('save_copy_link', 'Copy link')) + '</button>' : '') +
      '<button class="dsg-save__btn dsg-save__btn--ghost" type="button" data-dsg-close>' + esc(copy('save_keep_designing', 'Keep designing')) + '</button>' +
    '</div>';
  }

  function open(rec) {
    current = rec;
    build();
    lastFocus = doc.activeElement;
    el.innerHTML = formHtml();
    el.hidden = false;
    var form = el.querySelector('[data-dsg-form]');
    form.addEventListener('submit', onSubmit);
    var input = el.querySelector('#dsg-save-email');
    try { var remembered = root.sessionStorage.getItem('disegno.save_email'); if (remembered) input.value = remembered; } catch (e) {}
    setTimeout(function () { input.focus(); }, 30);
  }

  function close() {
    if (!el || el.hidden || busy) return;
    el.hidden = true;
    el.innerHTML = '';
    current = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function onSubmit(e) {
    e.preventDefault();
    if (busy || !current) return;
    var form = e.currentTarget;
    var input = form.querySelector('#dsg-save-email');
    var err = form.querySelector('#dsg-save-err');
    var email = String(input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      input.setAttribute('aria-invalid', 'true');
      err.textContent = copy('save_invalid_email', 'Please enter a valid email address.');
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    err.textContent = '';
    var marketing = !!form.querySelector('input[name="marketing"]').checked;
    var btn = form.querySelector('button[type="submit"]');
    busy = true; btn.disabled = true; btn.textContent = copy('save_saving', 'Saving…');
    try { root.sessionStorage.setItem('disegno.save_email', email); } catch (e2) {}

    var rec = JSON.parse(JSON.stringify(current));
    rec.email = email;
    var listId = (cfg().saved || {}).klaviyoListId || null;
    Disegno.SavedDesign.save(rec, { marketing: marketing, listId: listId })
      .then(function (res) {
        busy = false;
        el.innerHTML = successHtml(res);
        var cp = el.querySelector('[data-dsg-copy]');
        if (cp) cp.addEventListener('click', function () { copyLink(res.recovery_url, cp); });
        var first = el.querySelector('[data-dsg-copy]') || el.querySelector('.dsg-save__btn--ghost');
        if (first) first.focus();
      })
      .catch(function (e3) {
        busy = false; btn.disabled = false; btn.textContent = copy('save_submit', 'Email me my design');
        err.textContent = copy('save_error', 'Something went wrong saving your design. Please try again.');
        try { console.warn('[DiSEGNO] save failed', e3); } catch (_) {}
      });
  }

  function copyLink(url, btn) {
    var done = function () { btn.textContent = copy('save_copied', 'Copied'); };
    try {
      if (root.navigator.clipboard && root.navigator.clipboard.writeText) {
        root.navigator.clipboard.writeText(url).then(done, function () { selectLink(); });
        return;
      }
    } catch (e) {}
    selectLink();
  }
  function selectLink() {
    var n = el && el.querySelector('[data-dsg-link]');
    if (!n) return;
    try { var r = doc.createRange(); r.selectNodeContents(n); var s = root.getSelection(); s.removeAllRanges(); s.addRange(r); } catch (e) {}
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(el.querySelectorAll('button,input,[href]'), function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  Disegno.SaveDialog = { open: open, close: close };
})(window, document);
